<template>
    <div>
        <div class="row" id="audiogramaRef" ref="grafico">
            <svg
                version="1.2"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-labelledby="title"
                role="img"
                :style="styleAudiograma"
                id="svgLinha"
            >
                <title id="title">Imitância Acústica</title>
                <g
                    class="grid x-grid"
                    id="xGrid"
                    style="stroke: #ccc; stroke-dasharray: 0; stroke-width: 1"
                >
                    <line
                        :x1="5 + index * ((largura - 100) / 9)"
                        :x2="5 + index * ((largura - 100) / 9)"
                        :y1="10"
                        :y2="altura - 90"
                        :stroke="index == 8 ? 'black' : 'lightgray'"
                        v-for="(n, index) in 9"
                        :key="index"
                    ></line>
                </g>
                <g
                    class="grid y-grid"
                    id="yGrid"
                    style="stroke: #ccc; stroke-dasharray: 0; stroke-width: 1"
                >
                    <line
                        :x1="5"
                        :x2="largura - 150"
                        :y1="10 + index * ((altura - 100) / 5)"
                        :y2="10 + index * ((altura - 100) / 5)"
                        :stroke="index == 5 ? 'black' : 'lightgray'"
                        v-for="(n, index) in 6"
                        :key="index"
                    ></line>
                </g>

                <g
                    class="labels x-labels"
                    style="text-anchor: middle; font-size: 13px"
                >
                    <!-- <text :x="100 + 1 * ((largura - 100) / 8)" :y="altura - 75">
                        125
                    </text> -->
                    <text :x="1 * ((largura - 150) / 8)" :y="altura - 75">
                        -500
                    </text>
                    <text :x="2 * ((largura - 150) / 8)" :y="altura - 75">
                        -400
                    </text>
                    <text :x="3 * ((largura - 150) / 8)" :y="altura - 75">
                        -300
                    </text>
                    <text :x="4 * ((largura - 150) / 8)" :y="altura - 75">
                        -200
                    </text>
                    <text :x="5 * ((largura - 150) / 8)" :y="altura - 75">
                        -100
                    </text>
                    <text :x="6 * ((largura - 150) / 8)" :y="altura - 75">
                        0
                    </text>
                    <text :x="7 * ((largura - 150) / 8)" :y="altura - 75">
                        100
                    </text>
                    <text :x="8 * ((largura - 150) / 8)" :y="altura - 75">
                        200
                    </text>

                    <text :x="(largura - 150) / 2" :y="altura - 55">
                        Pressão
                    </text>
                </g>
                <g
                    class="labels y-labels"
                    style="text-anchor: end; font-size: 13px"
                >
                    <text :x="largura - 120" :y="15 + 0 * ((altura - 100) / 5)">2.5</text>
                    <text :x="largura - 120" :y="15 + 1 * ((altura - 100) / 5)">2</text>
                    <text :x="largura - 120" :y="15 + 2 * ((altura - 100) / 5)">1.5</text>
                    <text :x="largura - 120" :y="15 + 3 * ((altura - 100) / 5)">1</text>
                    <text :x="largura - 120" :y="15 + 4 * ((altura - 100) / 5)">0.5</text>
                    <text :x="largura - 120" :y="15 + 5 * ((altura - 100) / 5)">0</text>

                    <text :x="largura - 80" :y="(altura - 100) / 2">Vol.</text>
                </g>

                 <template v-for="(imitancia, index1) in dados">
                    <g class="data" data-setname="Ouvido Direito" :key="index1" v-if="imitancia.ouvido == 'direito'">
                        <template v-for="(item, index2) in imitancia.valores">
                            <template v-if="imitancia.valores[index2].valor != null">
                                <line
                                    v-if="
                                    index2 + 1 <= imitancia.valores.length - 1 &&
                                    imitancia.valores[index2 + 1].valor != null &&
                                    imitancia.valores[index2].valor != null
                                    "
                                    :x1="calcularX(item.freq)"
                                    :y1="calcularY(item.valor)"
                                    :x2="calcularX(imitancia.valores[index2 + 1].freq)"
                                    :y2="calcularY(imitancia.valores[index2 + 1].valor)"
                                    :stroke="imitancia.ouvido == 'direito' ? 'red' : 'blue'"
                                    :key="'linha1' + index1 + index2"
                                />
                            </template>
                        </template>
                    </g>
                    <g class="data" data-setname="Ouvido Esquerdo" :key="index1" v-else>
                        <template v-for="(item, index2) in imitancia.valores">
                            <template v-if="imitancia.valores[index2].valor != null">
                                <line
                                    v-if="
                                    index2 + 1 <= imitancia.valores.length - 1 &&
                                    imitancia.valores[index2 + 1].valor != null &&
                                    imitancia.valores[index2].valor != null
                                    "
                                    :x1="calcularX(item.freq)"
                                    :y1="calcularY(item.valor)"
                                    :x2="calcularX(imitancia.valores[index2 + 1].freq)"
                                    :y2="calcularY(imitancia.valores[index2 + 1].valor)"
                                    :stroke="imitancia.ouvido == 'direito' ? 'red' : 'blue'"
                                    :key="'linha1' + index1 + index2"
                                />

                                <!-- X -->
                                <text
                                    :x="calcularX(item.freq) - 5"
                                    :y="calcularY(item.valor) + 5"
                                    fill="blue"
                                    :key="'linha1_x' + index1 + index2"
                                >X</text>
                            </template>
                        </template>
                    </g>
                 </template>
            </svg>
        </div>
    </div>
</template>

<script>
// import _ from 'lodash';

export default {
    data() {
        return {
            frequencias: [-500, -400, -300, -200, -100, 0, 100, 200],
            resizeObj: null,
            largura: 800
        };
    },
    props: {
        dados: { type: Array },
        // largura: { type: Number, default: 800 },
        altura: { type: Number, default: 500 }
    },
    computed: {
        styleAudiograma() {
            return (
                "height: " + this.altura + "px; width: " + this.largura + "px;" + "padding-left: 60px;"
            );
        }
    },
    methods: {
        calcularX(fz) {
            // const indexFrequencia = this.frequencias.findIndex(e => e == fz);
            // const valorX =
            //     5 + (indexFrequencia + 1) * ((this.largura - 100) / 9);
            const valorX = this.findFrequenciaIndex(fz);
            return valorX;
        },

        calcularY(db) {
            const valorY = this.findVolumeIndex(db);
            return valorY;
        },

        findFrequenciaIndex(value) {
            let indexFreq = 0;
            let ajuste = 0.0;
            value = Number(value);

            if(value >= -500 && value < -400) {
                indexFreq = 1;
                ajuste = value + 500;
            }
            if(value >= -400 && value < -300) {
                indexFreq = 2;
                ajuste = value + 400;
            }
            if(value >= -300 && value < -200) {
                indexFreq = 3;
                ajuste = value + 300;
            }
            if(value >= -200 && value < -100) {
                indexFreq = 4;
                ajuste = value + 200;
            }
            if(value >= -100 && value < 0) {
                indexFreq = 5;
                ajuste = value + 100;
            }
            if(value >= 0 && value < 100) {
                indexFreq = 6;
                ajuste = value;
            }
            if(value >= 100 && value < 200) {
                indexFreq = 7;
                ajuste = value - 100;
            }
            if(value >= 200 && value <= 300) {
                indexFreq = 8;
                ajuste = value - 200;
            }

            return (5 + (indexFreq) * ((this.largura - 100) / 9)) + (ajuste / 2);
        },

        findVolumeIndex(value) {
            let indexVolume = 0;
            let ajuste = 0.0;

            if (value == 0) indexVolume = 5;

            if (value > 0 && value <= 0.5) {
                indexVolume = 4;
                ajuste = 0.5 - value;
            }

            if (value > 0.5 && value <= 1) {
                indexVolume = 3;
                ajuste = 1 - value;
            }

            if (value > 1 && value <= 1.5) {
                indexVolume = 2;
                ajuste = 1.5 - value;
            }

            if (value > 1.5 && value <= 2) {
                indexVolume = 1;
                ajuste = 2 - value;
            }

            if (value > 2 && value <= 2.5) {
                indexVolume = 0;
                ajuste = 2.5 - value;
            }

            if (value > 2.5) {
                ajuste = 2.5 - value;
            }

            return (10 + indexVolume * ((this.altura - 100) / 5)) + (ajuste * 100);
        },

        onResize() {
            this.largura = this.$refs.grafico.clientWidth;
        }
    },
    mounted() {
        this.largura = this.$refs.grafico.clientWidth;

        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    }
};
</script>

<style></style>
